export default __webpack_public_path__ + "static/media/total-bet.ceff572f.png";